(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var format = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function property(item, name) {
    return item && item.properties ? item.properties[name] : null;
  }

  async function fetchCart() {
    return (await fetch(ROOT + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
  }

  async function reconcileConfiguredCart(cart) {
    var parentQuantities = {};
    var updates = {};

    cart.items.forEach(function (item) {
      var parentKey = property(item, '_cl_lens_configuration');
      if (parentKey) parentQuantities[parentKey] = Number(item.quantity || 0);
    });

    cart.items.forEach(function (item) {
      var addOnKey = property(item, '_tpo_add_on_key');
      if (!addOnKey) return;

      var targetQuantity = parentQuantities[addOnKey] || 0;
      if (Number(item.quantity || 0) !== targetQuantity) {
        updates[item.key] = targetQuantity;
      }
    });

    if (!Object.keys(updates).length) return cart;

    var response = await fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    });
    var updatedCart = await response.json();
    if (!response.ok) throw new Error(updatedCart.description || updatedCart.message || 'Unable to synchronize configured cart items.');

    document.dispatchEvent(new CustomEvent('cart:refresh'));

    if ((window.themeVariables && window.themeVariables.settings.pageType === 'cart') || window.location.pathname === ROOT + 'cart') {
      /* A synchronous reload can be ignored while Shopify is still finishing
         the cart/change navigation. Queue it so the cleaned cart is rendered. */
      window.setTimeout(function () { window.location.reload(); }, 120);
    }

    return updatedCart;
  }

  async function refreshConfiguredPrices() {
    try {
      var cart = await fetchCart();
      cart = await reconcileConfiguredCart(cart);

      if (!document.querySelector('[data-cl-config-key], [data-cl-config-line-total]')) return;

      var totals = {};

      cart.items.forEach(function (item) {
        var parentKey = property(item, '_cl_lens_configuration');
        var addOnKey = property(item, '_tpo_add_on_key');
        var key = parentKey || addOnKey;
        if (!key) return;
        totals[key] = (totals[key] || 0) + Number(item.final_line_price || 0);
      });

      document.querySelectorAll('[data-cl-config-key]').forEach(function (line) {
        var total = totals[line.getAttribute('data-cl-config-key')];
        var price = line.querySelector('price-list sale-price');
        if (price && total != null && price.dataset.clConfiguredCents !== String(total)) {
          price.dataset.clConfiguredCents = String(total);
          price.innerHTML = '<span class="sr-only">Sale price</span>' + money(total);
        }
      });

      document.querySelectorAll('[data-cl-config-line-total]').forEach(function (cell) {
        var total = totals[cell.getAttribute('data-cl-config-line-total')];
        if (total != null && cell.dataset.clConfiguredCents !== String(total)) {
          cell.dataset.clConfiguredCents = String(total);
          cell.textContent = money(total);
        }
      });
    } catch (error) {
      console.error('[native-lens-cart] Unable to refresh configured prices', error);
    }
  }

  var scheduled = null;
  var refreshing = false;
  function scheduleRefresh() {
    clearTimeout(scheduled);
    scheduled = setTimeout(async function () {
      if (refreshing) return;
      refreshing = true;
      try {
        await refreshConfiguredPrices();
      } finally {
        refreshing = false;
      }
    }, 80);
  }

  document.addEventListener('DOMContentLoaded', scheduleRefresh);
  document.addEventListener('cart:change', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);
  document.addEventListener('variant:add', scheduleRefresh);

  new MutationObserver(function (mutations) {
    var cartChanged = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return false;

        return node.matches('[data-cl-config-key], [data-cl-config-line-total], cart-drawer, .cart-drawer') ||
          node.querySelector('[data-cl-config-key], [data-cl-config-line-total]');
      });
    });

    if (cartChanged) scheduleRefresh();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
